<template>
  <b-col md="12" sm="12">
    <b-card no-body class="mx-4">
      <b-card-body class="p-12">
        <h1 tabindex="0">{{ form.titulo }}</h1>
        <b-row>
          <b-col cols="12">
            <div tabindex="0" v-html="form.descricao"></div>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <b-card no-body class="mx-4">
        <b-row>
          <b-col class="col-sm-12">
            <div style="background-color: #FAAF40; padding-top: 5px; padding-bottom: 1px;">
              <p tabindex="0" style="font-size: 16px">&nbsp;<strong>Mensagens</strong></p>
            </div>
            <b-card style="height: 300px; overflow: auto;">
              <ul v-if="form.comentarios.length > 0">
                <li v-for="comentario in form.comentarios" :key="comentario.id">
                  <p tabindex="0"><strong>{{ comentario.nome_social ? comentario.nome_social : comentario.usuario }} - {{ comentario.uf ? comentario.uf : comentario.uf_user }}   - {{ comentario.created_at }}</strong></p>
                  <div class="p-3 mb-2 bg-primary text-white" style="border-radius: 10px; width: 50%;">{{ comentario.comentario }}</div>
                </li>
              </ul>
              <ul v-else>
                <li>
                  <i tabindex="0">Nenhuma mensagem.</i>
                </li>
              </ul>
              <b-row>
                <b-col cols="10">
                  <b-form-textarea placeholder="Digite sua mensagem" tabindex="0" id="textarea" rows="3"
                    v-model="comentario"></b-form-textarea>
                </b-col>
                <b-col cols="2" align-self="end">
                  <b-button block variant="success" @click="enviarComentario()">
                    <i class="fa fa-paper-plane-o" aria-hidden="true"></i>&nbsp;&nbsp;<span>Enviar</span>
                  </b-button>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </b-card>  
    <b-card no-body class="mx-4">
      <b-card-footer class="p-12">
        <b-row>
          <b-col md="3">
            <b-button block variant="secondary" @click="navigate('/salachat')">
              <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;<span>Voltar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>

    <b-modal title="Incluir Comentários" size="lg" cancel-title="Cancelar" v-model="modalComentario" @ok="enviarComentario()">
      <b-card-body>
        <b-form>
          <b-row>
            <b-col cols="12">
              <h3 tabindex="0" style="color: #339966; margin-bottom: 20px; font-weight: bold; text-align: center">Insira aqui seu Comentário</h3>
            </b-col>
          </b-row>
          <b-row>
            <b-col tabindex="0" cols="2">
              <strong>Comentário:</strong>
            </b-col>
            <b-col cols="10">
              <b-form-textarea tabindex="0" id="textarea" rows="8" v-model="comentario"></b-form-textarea>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
    </b-modal>

  </b-col>
</template>

<script>
import Vue from 'vue'
import Pagination from '@/components/shared/Pagination'
import VueSelect from 'vue-select'
import {validationMixin} from 'vuelidate'
import miniToastr from 'mini-toastr'
import Multiselect from 'vue-multiselect'
import {eventType} from '@/components/shared/eventType'
import SessionStorage from '@/services/session-storage'

miniToastr.init()

export default {
  name: 'Cadastro',
  components: {
    Pagination,
    VueSelect,
    Multiselect
  },
  mixins: [validationMixin],
  created () {
    if (!this.can('salachat.comentarios')) {
      // this.$router.push('/')
    }
    this.buscaPermissoesFormulario() 
  },
  destroyed () {
    clearInterval(this.loopComentarios)
  },
  mounted () {
  },
  data () {
    return {
      loading: false,
      conferencia_id: SessionStorage.get('conferencia_atual_id'),
      usuario_id: SessionStorage.get('usuario'),
      form: {
        id: '',
        titulo: '',
        descricao: '',
        mocao: '',
        totalAprovado: 0,
        totalReprovado: 0,
        avaliacoes: {},
        comentarios: []
      },
      permissaoAdicionarComentario: false,
      votacao: true,
      modalAprovacao: false,
      modalRejeicao: false,
      resourceAprovacao: '',
      resourceRejeicao: '',
      filtros: {
        aprovado: null
      },
      load: false,
      propostaAtual: null,
      modalComentario: false,
      textoAtualSugestao: '',
      sugestaoEdicao: '',
      comentario: '',
      resourceSugestao: '',
      resourceComentario: '',
      modalSugestaoEdicao: false,
      usuarioAtual: 0,
      disable_buttons: false,
      titulo_toast: 'Alerta!',
      salvarForm: false,
      loopComentarios: null,
      perguntas_respostas: [],      
    }
  },
  computed: {
    avaliacoes () {
      return this.$store.state.pagination.getList
    },
    exclusoes () {
      return this.$store.state.pagination.getList
    },
    comentarios () {
      return this.$store.state.pagination.getList
    },
    isValid () {
      return !this.$v.form.$anyError
    },
    isValidSelection () {
      return this.selected !== '' && this.selected !== 'forbidden value'
    }
  },
  methods: {
    loadNewComentarios () {
      this.loopComentarios = setInterval(() => this.loadComentarios(this.$route.params.id), 30000)
    },
    loadModalComentarios () {
      this.modalComentario = true
      this.comentario = ''
    },
    loadModalAprovacao () {
      this.resourceAprovacao = 'mocao/' + this.$route.params.id + '/avaliacao'
      this.filtros.aprovado = true
      this.modalAprovacao = true
    },
    loadModalRejeicao () {
      this.resourceRejeicao = 'mocao/' + this.$route.params.id + '/avaliacao'
      this.filtros.aprovado = false
      this.modalRejeicao = true
    },
    loadSalaChat (id) {
      Vue.http.get('api/salachat/contribuicao/' + id).then(response => {
        let data = response.body.data
        this.form.id = data.id
        this.form.titulo = data.titulo
        this.form.descricao = data.descricao
        let verifica_pergunta = null
        let verifica_alternativa = null
        if(data.respostas.length > 0){
        
           for (let indice in data.respostas) { 
                if(this.perguntas_respostas){
                  for (let index in this.perguntas_respostas) { 
                    if(this.perguntas_respostas[index].pergunta_id == data.respostas[indice].pergunta_id){
                      verifica_pergunta = true
                    }
                    if(this.perguntas_respostas[index].alternativa_id == data.respostas[indice].alternativa_id){
                      verifica_alternativa = true
                    }
                }
            }
            if(verifica_pergunta && verifica_alternativa){
              if(data.respostas[indice].comentar){
                this.permissaoAdicionarComentario = true
              }
            }
          }
        } else {
          this.permissaoAdicionarComentario = true
        }
      })
    },
    loadIdProxima () {
      Vue.http.get('api/salachat/proxima/transmissao/obter').then(response => {
        let proxima = response.body.data
        console.log(proxima)
      })
    },
    buscaPermissoesFormulario() {   
       Vue.http.get('api/formulario/buscarPermissoesFormulario/' + this.conferencia_id + '/' + this.usuario_id).then(response => { 
           if (response.body.success) {
             let data = response.body.data.data
             if(data !== undefined){
               this.perguntas_respostas = data.respostas.perguntas_respostas               
             }             
           }   
          this.loadSalaChat(this.$route.params.id)
          this.loadComentarios(this.$route.params.id)          
          this.loadNewComentarios()      
       })
    },
    loadComentarios (id) {
      let last = this.form.comentarios.length
      if (last !== 0) {
        last = this.form.comentarios[last - 1].id
      }

      let limit = 50

      Vue.http.get('api/salachat/' + id + '/comentario?last_id=' + last + '&length=' + limit).then(response => {
        // this.permissaoAdicionarComentario = response.body.data.permissao

        let data = response.body.data.data.data
        let dataTmp = []
        for (let x in data) {
          dataTmp.push(data[x])
        }

        if (last === 0) {
          dataTmp = dataTmp.reverse()
          this.form.comentarios = dataTmp
        } else {
          for (let x in dataTmp) {
            this.form.comentarios.push(dataTmp[x])
          }
        }
      })
    },
    loadListaComentarios (id) {
      let last = 0
      let limit = 50
      clearInterval(this.loopComentarios)
      Vue.http.get('api/salachat/' + id + '/comentario?last_id=' + last + '&length=' + limit).then(response => {
        // this.permissaoAdicionarComentario = response.body.data.permissao

        let data = response.body.data.data.data
        let dataTmp = []
        for (let x in data) {
          dataTmp.push(data[x])
        }

        dataTmp = dataTmp.reverse()
        this.form.comentarios = dataTmp
        this.loadNewComentarios()
      })
    },
    enviarComentario () {
      this.$bvModal.msgBoxConfirm('Confirma o envio do comentário?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          let data = {
            comentario: this.comentario
          }

          this.loading = true
          Vue.http.post('api/salachat/' + this.form.id + '/comentario', data).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.modalComentario = false
              this.comentario = ''
            } else {
              miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
              miniToastr.error(response.body.msg, 'Alerta', 5000)
            }
            this.loading = false
            this.loadListaComentarios(this.form.id)
          }).catch(e => {
            console.log('Servidor está fora! ' + e)
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    aprovar () {
      this.$bvModal.msgBoxConfirm('Confirma a aprovação?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.loading = true
          Vue.http.put('api/salachat/' + this.$route.params.id + '/aprovada').then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
            } else {
              miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
              miniToastr.error(response.body.msg, 'Alerta', 5000)
            }
            this.loading = false
            this.load = false
            this.cancelar()
          }).catch(e => {
            console.log('Servidor está fora! ' + e)
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    rejeitar () {
      this.$bvModal.msgBoxConfirm('Confirma a rejeição?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.loading = true
          Vue.http.put('api/salachat/' + this.$route.params.id + '/rejeitada').then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
            } else {
              miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
              miniToastr.error(response.body.msg, 'Alerta', 5000)
            }
            this.loading = false
            this.load = false
            this.cancelar()
          }).catch(e => {
            console.log('Servidor está fora! ' + e)
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    cancelar () {
      this.modalAprovacao = false
      this.modalRejeicao = false
    },
    setarFiltros (filtros) {
      eventType.$emit('app', filtros)
    },
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="vue-wysiwyg/dist/vueWysiwyg.css"></style>



// WEBPACK FOOTER //
// src/pages/site/interna/salaChat/SalaChatConsulta.vue